const baseUrl = `${process.env.REACT_APP_BASE_URL}`;
// const publicContentBaseUrl = `${process.env.REACT_APP_PUBLIC_CONTENT_API_URL ||
//   process.env.REACT_APP_CAROUSEL_API_URL ||
//   process.env.REACT_APP_BASE_URL
//   }`;

const API_URL = {
  //CONSUMER
  SEND_OTP: `carhire-customer-merchant/customer/service/otp/sendotp`,
  VERIFY_OTP: `carhire-customer-merchant/customer/service/otp/validateotp`,
  REGISTER: `carhire-customer-merchant/customer/service/consumers/register`,
  T_OTP: `carhire-customer-merchant/authentication/generate/totp`,
  LOGIN: `carhire-customer-merchant/authentication/login`,
  PVT_KEY: `carhire-customer-merchant/authentication/privateKey`,
  DOC_UPLOAD: `carhire-customer-merchant/customer/service/documents/upload`,
  BOOKING_NOW: `carhire-customer-merchant/customer/service/consumers`,
  DELIVERY_ADDRESS: `carhire-customer-merchant/customer/service/master/deliveryaddress`,
  PRODUCT_SEARCH: `carhire-product-consumer//product-data/location-and-filter`,
  CUSTOMER_DETAILS:
    "carhire-customer-merchant/customer/service/consumers/details",
  CLEAR_CART: "/carhire-customer-merchant/customer/service/consumers",
  GET_CART: "carhire-customer-merchant/customer/service/consumers",
  COUNTRY: `carhire-customer-merchant/customer/service/master/country`,
  STATE: `carhire-customer-merchant/customer/service/master/state/`,
  CAROUSAL_HOME: `carhire-customer-merchant/customer/service/carousal/home-carousel?platform=web`,
  HOME_SERVICES: `api/v1/public/home-services?platform=web`,
  HOME_SERVICE_CATEGORIES: `api/v1/public/home-services/categories`,
  HOME_SERVICE_DETAIL: `api/v1/public/home-services`,
  CAMPAIGN_CODE: `carhire-customer-merchant/customer/service/campaign/get-by-code`,

  BOOKED_ORDERS: `carhire-order/order/service/consumers/orders/customer`,
  ADDITIONAL_OPTIONS: "carhire-product-consumer/additional-options/get-status",
  PRODUCT_UPGRADE: `carhire-product-consumer/products/upgrade`,
  CAR_TYPES: `carhire-product-consumer/products/car-types`,
  CUSTOMER_ORDER: "carhire-order/order/service/consumers/orders/customer",
  CUSTOMER_ORDER_DETAILS: "carhire-order/order/service/consumers/orders",
  CUSTOMER_ORDER_EDIT: "carhire-order/order/service/consumers/orders/edit",
  CUSTOMER_ORDER_CANCEL: "carhire-order/order/service/consumers/orders/cancel",
  GET_NEAREST_MERCHANT: "carhire-customer-merchant/customer/service/merchant/details/get-nearest-merchant-product",
  CRM_LEADS: "carhire-customer-merchant/customer/service/campaign/create/crm-leads",
  CAMPAIGN_DATA: "carhire-customer-merchant/customer/service/campaign/get-by-code",
  CREATE_WISHLIST: "carhire-customer-merchant/customer/service/master/create-wishlist",
  MARKETING_ASSETS: "carhire-customer-merchant/customer/service/social-media/content/marketing-assets",
  MERCHANT_PERCENTAGE: "carhire-order/order/service/merchant-payment-config/merchant",
  CUSTOMER_ACCOUNT_DELETE: "carhire-customer-merchant/authentication/delete-user",
  DRIVER_FEE_CONFIG: "carhire-order/order/service/merchant-payment-config/driver-fee",
  OCR: "/LICENCE_OCR/extract_all",

  //MERCHANT

  SIGNUP_MERCHANT:
    "carhire-customer-merchant/customer/service/consumers/details",
  LICENSE_DETAILS_MERCHANT:
    "carhire-customer-merchant/customer/service/consumers/details",
  KYC_DETAILS_MERCHANT:
    "carhire-customer-merchant/customer/service/consumers/details",
  INSURANCE_COMPANY_LIST_MERCHANT:
    "carhire-customer-merchant/customer/service/master/insurance-companies",
  PRODUCT_LIST: "carhire-product-merchant/products/get-products",
  FULL_ACCESS:
    "carhire-customer-merchant/customer/service/consumers/dummy-approval",
  BUSINESS_TYPE:
    "carhire-customer-merchant/customer/service/master/businessdetails",
  FORGOT_PASSWORD:
    "carhire-customer-merchant/customer/service/consumers/forgotPassword",
  MERCHANT_LIST:
    "carhire-customer-merchant/customer/service/consumers/merchants/odoo",
  UPDATE: "carhire-customer-merchant/customer/service/consumers",
  CREATE_CART: "carhire-order/order/service/consumers/orders/create",
  ORDER_DETAILS: "carhire-order/order/service/merchants",
  DELIVERY_SLOT_UPDATE: "carhire-order/order/service/merchants/statusUpdate",

  INSURANCE_CART: "carhire-customer-merchant/customer/service/consumers",
  INSURANCE_COMPANY_SEARCH:
    "carhire-customer-merchant/customer/service/master/insurance-companies-keyword",
  GARAGE_SEARCH:
    "carhire-customer-merchant/customer/service/merchant/details/basic-details",
  DELIVERYBOY_LIST:
    "carhire-customer-merchant/customer/service/merchant/details/delivery-boys",
  // "carhire-customer-merchant/customer/service/admin/customers",

  DELIVERYBOY_DETAILS:
    "carhire-customer-merchant/customer/service/admin/delivery-partner/",
  DELIVERBOY_APPROVAL:
    "carhire-customer-merchant/customer/service/admin/merchants/status",
  // DELIVERY_FEE:
  //   "carhire-order/order/service/deliveryfee/calculate-delivery-fee",
  DELIVERY_FEE: "carhire-order/order/service/deliveryfee/merchant",
  DELIVERYBOY_ASSIGN: "carhire-order/order/service/deliveryPartner",
  BANK: `/carhire-customer-merchant/customer/service/master/getBankDetails/all`,
  PROFILE: `/carhire-customer-merchant/customer/service/consumer/account-settings`,
  SEARCH_RESULTS: `/carhire-order/order/service/consumers/orders/get-orders/details`,
  GET_COMMENTS: "carhire-order/order/service/consumers/orders/get-message",
  BULK_APPROVAL: `/carhire-order/order/service/merchants/update/multiple_orders`,
  EXPORTLIST_SEARCH_RESULTS:
    "/carhire-order/order/service/merchants/all-orders",
  CHILD_BRANCHES: "/carhire-customer-merchant/customer/service/admin/merchant-type/get-child-merchants",
  UPDATE_RENTAL_DOCUMENTS: "/carhire-order/order/service/merchants/update-rental-documents",
  MERCHANT_ORDER_COUNT: "/carhire-order/order/service/merchants/merchant-order-count",

  //PRODUCT

  PRODUCT_CATEGORY_LIST:
    "carhire-product-merchant/category?planet_id=CarRentalPlanet",
  CREATE_PRODUCT: "carhire-product-merchant/products",
  PRODUCT_IMAGE_UPLOAD:
    "carhire-customer-merchant/customer/service/uploadProductImage",
  FEATURE_LIST: "carhire-product-merchant/products/features/all",
  VIEW_PRODUCT_DETAILS: `carhire-product-merchant/products/`,
  PRODUCT_DELETE: `carhire-product-merchant/products/enable_disable`,
  PURCHASE_ORDER: `carhire-order/order/service/merchants`,
  APPROVE_REJECT: `carhire-order/order/service/merchants/statusUpdate`,

  CUSTOMER_DOCUMENTS: `carhire-customer-merchant/customer/service/documents`,
  PRODUCT_BULKUPLOAD: "carhire-product-merchant/upload/products",
  INSURANCE_PRODUCT_LISTING: `carhire-product-consumer/get-insurance-products`,

  //GARAGE

  GARAGE_ORDER_LISTING: "carhire-order/order/service/garage/order_details",
  GARAGE_ORDER_DETAILS: "carhire-order/order/service/garage/order-details",
  GARAGE_STATUS_UPDATE:
    "carhire-order/order/service/garage/update-garage-status",
  EXTRA_AMOUNT:
    "carhire-product-consumer/cart-amount-config/getCartAmountConfiguration",
  ADDITIONAL_DRIVER_FEE:
    "carhire-order/order/service/deliveryfee/list-driver_fee",
  VEHICLE_REASSIGN: "carhire-product-merchant/products/available-products",
  SLOT: "carhire-order/order/service/merchants/get-delivery-slot",
  CAR_CHANGE_UPDATE:
    "carhire-order/order/service/merchants/order-product-change",
  RENTAL_DAYS: "carhire-order/order/service/merchants/update/rental-days",
  REFRESH_TOKEN: "carhire-customer-merchant/authentication/oauth/refresh/token",
  BOOKING_CALENDER:
    "carhire-order/order/service/consumers/orders/order/status/timeline",

  //LPo

  ORDER_EDIT: `carhire-order/order/service/merchants/order-change-request`,

  //NOTIFICATION

  NOTIFICATION_COUNT:
    "notification/notification/get_viewed_notifications/BACKOFFICE_ORDER_ACCEPT",
  NOTIFICATION_UPDATE: "notification/notification/update/push_notification",
  NOTIFICATION_LIST: "notification/merchant/get-all-messages",

  //AFL
  CREATE_SERVICE: "/carhire-order/order/service/afl-order/create-afl-order",
  SERVICE_TYPES: "carhire-order/order/service/serviceTypes/get-services/ALL",
  EMIRATES_CODE: "carhire-delivery/kirkos/delivery-vehicle/get-emirates",
  MAKE_MODEL_LIST: "carhire-product-consumer/road_assistance/get-all-vehicles",
  SERVICE_LIST: "carhire-order/order/service/afl-order/get/afl-order",
  CANCEL_SERVICE: "carhire-order/order/service/afl-order/cancel/afl-order",
  SERVICE_DETAILS: "carhire-order/order/service/backoffice/",
  SERVICE_DETAILS_EDIT: "/carhire-order/order/service/afl-order/process/service-details",
  RESCHEDULE_SERVICE: "carhire-order/order/service/afl-order/reschedule",
  EXPORT_LIST: "carhire-order/order/service/afl-order/get-all/export-data",
  ORDER_COUNT: "/carhire-order/order/service/afl-order/order-count",

  PAY: "carhire-order/order/stripePayment/create-session",
  PAY_MOBILE: "carhire-order/order/stripePayment/create-payment-intent",

  GET_LOCATIONS: "carhire-order/order/service/afl-order/get-all/afl-locations",
  GET_GOOGLELOCATIONS: "/carhire-order/order/service/maps-google/places/search",
  DRIVER_LOCATION: "/carhire-delivery/kirkos/delivery/delivery-location-by-order-number",
  CHECKLIST_IMAGE_EDIT: "/carhire-order/order/service/afl-order/update/afl-service-details",
  LOCATION_BASED_SERVICE: "/carhire-order/order/service/serviceTypes/get-services/LOCATION_BASED?type=AFL",
  VEHICLE_CREATE: "/carhire-product-consumer/road_assistance/create/vehicles",
  CREATE_VEHICLE_LOCATIONS: "/carhire-order/order/service/afl-order/create/afl-location",
  REGISTER_USER: "/carhire-customer-merchant/customer/service/consumers/register",
  ADD_USER_DETAILS: "/carhire-customer-merchant/customer/service/consumers/details",

  // Vendor
  GET_DRIVERS: "/carhire-customer-merchant/customer/service/merchant/details/delivery-boys",
  GET_DRIVER_DETAILS: "/carhire-customer-merchant/customer/service/admin/delivery-partner",
  GET_DOCUMENTS: "/carhire-customer-merchant/customer/service/documents",
  DOCUMENTS_UPLOAD: "/carhire-customer-merchant/customer/service/documents/upload",
  DOCUMENTS_EDIT: "/carhire-customer-merchant/customer/service/admin/details",
  APPROVE_DRIVER: "/carhire-customer-merchant/customer/service/admin/merchants/status",
  GET_ORDERS: "/carhire-order/order/service/serviceDetails/road-side-assistance/get-orders",
  GET_DRIVER_OTPS: "/carhire-customer-merchant/customer/service/otp/active-otp",
  CHARGE_OFF_SESSION: "carhire-order/order/stripePayment/charge-off-session",
  SERVICE_CONFIGS: "carhire-order/order/service/serviceDetails/configs",
  KIRKOS_SERVICES_ACTIVE: "carhire-order/order/service/kirkosServices/active",
  KIRKOS_SERVICE_CREATE: "carhire-order/order/service/serviceDetails/kirkos/create-order",
  KIRKOS_SERVICE_LOCATIONS: "carhire-order/order/service/kirkosServices/locations",
  KIRKOS_CONSUMER_SERVICES: "carhire-order/order/service/consumers/orders/consumer-services",
};

export { baseUrl, API_URL };
